/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.partners.orders.detail.controllers', [
  'acme.common.service.api',
  'acme.common.service.calendar',
  'acme.common.service.order'
])

.controller('PartnersOrdersDetailController', ['$scope', '$state', '$filter', 'ApiService', 'CalendarService', 'OrderService', 'OrderData', function($scope, $state, $filter, ApiService, CalendarService, OrderService, OrderData) {

    $scope.partnersOrdersDetail = {

      model: {},
      isEditing: false,
      isSaving: false,

      getItemType: OrderService.getItemType,

      init: function() {

        $scope.$emit('Application::contentTitleChange', {
          title: 'Organization Order Details',
          buttonRight: {
            label: 'Edit Order',
            permissions: ['ACCT_ORDERS_UPDATE'],
            action: function() {
              $state.go('application.orders.edit', { accountId: $scope.partnersOrdersDetail.model.accountId, orderId: $scope.partnersOrdersDetail.model.orderId });
            }
          }
        });

        if (OrderData && OrderData.data.success) {
          this.success.init(OrderData);
        }else{
          this.error.init(OrderData);
        }

      },

      process: function(order) {

        var i, ii;

        for (i=0,ii=order.eventItems.length;i<ii;i++) {
          if (order.eventItems[i].eventDate) {
            order.eventItems[i].startDate = $filter('date')(CalendarService.parseDate(order.eventItems[i].eventDate), 'M/d/yyyy');
            order.eventItems[i].startHour = $filter('date')(CalendarService.parseDate(order.eventItems[i].eventDate), 'h:mm a');
          }else{
            order.eventItems[i].startDate = 'Date N/A';
            order.eventItems[i].startHour = 'Time N/A';
          }
        }

        return order;

      },

      update: function() {
        this.model.notes = this.notes + '';
        this.isSaving = true;
        ApiService.orders.notes({
          id: $state.params.orderId,
          notes: this.model.notes
        }).then(this.success.update, this.error.update);
      },

      hasName: function() {
        return (this.model.contactFirstName || this.model.contactLastName);
      },

      cancel: function() {
        window.history.go(-1);
      },

      toggleEdit: function(isCancel) {
        if (isCancel) {
          this.notes = this.model.notes + '';
        }
        this.isEditing = !this.isEditing;
      },

      success: {
        init: function(response) {
          $scope.partnersOrdersDetail.model = $scope.partnersOrdersDetail.process(response.data.payload);
          $scope.partnersOrdersDetail.notes = $scope.partnersOrdersDetail.model.notes + '';
        },
        update: function(response) {
          $scope.partnersOrdersDetail.isSaving = false;
          $scope.partnersOrdersDetail.isEditing = false;
        }
      },

      error: {
        init: function(response) {
          $scope.partnersOrdersDetail.isSaving = false;
          $scope.partnersOrdersDetail.isEditing = false;
        }
      }

    };

    $scope.partnersOrdersDetail.init();

}]);